import script from "./AdminPrayerRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrayerRequest.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrayerRequest.vue?vue&type=style&index=0&id=3709dc08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3709dc08"]])

export default __exports__